
import React from 'react';
import { SERVICES } from '../constants';
import { Wrench, Settings, Shield, Globe } from 'lucide-react';
import { useData } from '../context/DataContext';
import FAQ from '../components/FAQ';

const iconMap: Record<string, React.ReactNode> = {
  wrench: <Wrench size={32} />,
  settings: <Settings size={32} />,
  shield: <Shield size={32} />,
  globe: <Globe size={32} />,
};

const Services: React.FC = () => {
  const { settings } = useData();

  return (
    <div className="min-h-screen bg-white pt-24">
      {/* Header */}
      <div className="bg-neutral-900 text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1580901368919-79848a43af05?auto=format&fit=crop&q=80&w=2000')] bg-cover bg-center opacity-30"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <h1 className="font-display text-6xl font-bold uppercase tracking-wide mb-4">
            World Class Support
          </h1>
          <p className="text-xl text-white max-w-3xl mx-auto">
            Keeping your fleet moving across East Africa with expert maintenance, genuine parts, and reliable logistics.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {SERVICES.map((service, index) => (
            <div
              key={service.id}
              className="flex gap-6 group"
            >
              <div className="flex-shrink-0 w-16 h-16 bg-red-50 text-automax-red rounded-sm flex items-center justify-center group-hover:bg-automax-red group-hover:text-white transition-colors duration-300">
                {iconMap[service.icon]}
              </div>
              <div>
                <h3 className="font-display text-2xl font-bold text-gray-900 uppercase mb-2 group-hover:text-automax-red transition-colors">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
                <a href="#" className="inline-block mt-4 text-sm font-bold uppercase tracking-wider text-gray-900 border-b-2 border-transparent group-hover:border-automax-red transition-all">Learn More</a>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Map Placeholder Section */}
      <div className="bg-gray-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2
            className="font-display text-4xl font-bold text-gray-900 uppercase mb-8"
          >
            Service Network
          </h2>
          <div
            className="relative bg-white p-8 rounded shadow-sm min-h-[400px] flex items-center justify-center border-2 border-dashed border-gray-300"
          >
            {/* Abstract Map Representation */}
            <div className="space-y-4">
              <p className="text-gray-500 font-bold uppercase tracking-widest">East Africa Service Hubs</p>
              <div className="flex flex-wrap justify-center gap-12">
                {['EAC Countries', 'Central Africa'].map((region, i) => (
                  <div
                    key={region}
                    className="flex flex-col items-center"
                  >
                    <div className="w-6 h-6 bg-automax-red rounded-full animate-pulse mb-3 shadow-lg shadow-red-500/50"></div>
                    <span className="font-display font-bold text-gray-800 text-xl uppercase tracking-wide">{region}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <FAQ
        items={settings.servicesFaqs}
        title="Services FAQ"
        subtitle="Common questions about our maintenance, parts, and support services."
        label="Service Support"
      />
    </div>
  );
};

export default Services;
